import { z } from "zod";

// ─── DocTypes ────────────────────────────────────────────────────────────────

export const docTypeIdSchema = z.string().uuid("ID de tipo de documento inválido");

export const createDocTypeSchema = z.object({
  name: z.string().min(1, "El nombre es requerido").max(200),
  code: z.string().min(1, "El código es requerido").max(10),
});

export const updateDocTypeSchema = createDocTypeSchema.partial();

export const docTypeQuerySchema = z.object({
  deleted: z.enum(["true", "false"]).optional(),
});

// ─── Inferred types ───────────────────────────────────────────────────────────

export type DocTypeId = z.infer<typeof docTypeIdSchema>;
export type CreateDocTypeInput = z.infer<typeof createDocTypeSchema>;
export type UpdateDocTypeInput = z.infer<typeof updateDocTypeSchema>;
export type DocTypeQuery = z.infer<typeof docTypeQuerySchema>;
